/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";

import { useParams, Link } from "react-router-dom";

import { TableTextWrapper } from "Components/Common/SharedTableStyles.styles";
import { ProfileTabs } from "Constants/ProfileConstants";

import { IProfileBenefitOtherTenantProps } from "./IProfileBenefitOtherTenantProps";

const ProfileBenefitOtherTenant = ({
  tenantName,
}: IProfileBenefitOtherTenantProps): React.ReactElement => {
  const { id } = useParams<{ id: string }>();

  return (
    <TableTextWrapper style={{ marginTop: "1rem" }}>
      This user is dual member and this benefit can be managed from&nbsp;
      <Link to={`/${tenantName.toLowerCase()}/details/${id}?tab=${ProfileTabs.Benefits}`} replace>
        here
      </Link>
      .
    </TableTextWrapper>
  );
};

export default ProfileBenefitOtherTenant;
